import React, { useEffect, useState } from 'react'
import TextInput from '../../form/TextInput'
import { enqueueSnackbar } from 'notistack';
import Button1 from '../../form/Button1';
import { CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import setPin from '../../../controllers/settings/pin/setPin';
import forgotPin from '../../../controllers/settings/pin/forgotPin';
import OTPInput from '../../Auth/OTPInput';

const initData = {pin: '',confirm: '', OTP: ''};
export default function TicketPinForm({callback,close}) {
    const {userData: {user}} = useSelector(state => state.user);
    const [data,setData] = useState(initData)
    const [forgotView,setForgotView] = useState(false);
    const [query,setQuery] = useState();
    const [loadings,setLoadings] = useState({submit: false,forgot: false,resend: true});

    useEffect(() => {
        setForgotView(false);
        setData(initData)
        setQuery()
    },[close])

    console.log(data)
    
    async function handleSubmit(ev) {
        ev?.preventDefault();

        if(data?.pin !== data?.confirm)
            return enqueueSnackbar('Pins doesn\'t match!',{variant: 'error'})

        if(user?.advancedSecurityEnabled && !forgotView)
          return handleForgotPin({isUpdate: true})
        

        setLoadings({...loadings,submit: true})
        const res = await setPin({pin: data?.pin,otp: forgotView ? data?.OTP : undefined});
        setLoadings({...loadings,submit: false})
        if(res?.return) {
            enqueueSnackbar(res.msg,{variant: 'success'})
            callback && callback()
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }
    
    async function handleForgotPin(query,config) {
      setQuery(query);
      const key = query?'submit':'forgot';

        setLoadings({...loadings,[key]: true, resend: config?.resend && true})
        const res = await forgotPin(new URLSearchParams(query)?.toString());
        setLoadings({...loadings,[key]: false, resend: config?.resend && false})
        if(res?.return) {
            enqueueSnackbar(res.msg,{variant: 'success'});
            setForgotView(true);
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }
    
  return (
    <form onSubmit={handleSubmit} className='flex flex-col gap-6 p-4 max-w-[600px] items-center'>
      <div>Please choose a pin for payment and ticketing authorization.
        <br />
        {forgotView?' We have sent a one time password (OTP) to your email':''}
      </div>
      <div className='flex flex-col gap-2 text-primary/80 text-center'>
        <small>New Pin</small>
        <OTPInput value={data?.pin} onChange={(pin) => setData({...data,pin})} />
      </div>
      {/* <TextInput label='Enter Pin' placeholder={'e.g 4904290540'} required
        value={data?.pin}
        onChange={(ev) => setData({...data,pin: ev.target.value})}
      /> */}
      <div className='flex flex-col gap-2 text-primary/80 text-center'>
        <small>Confirm Pin</small>
        <OTPInput value={data?.confirm} onChange={(confirm) => setData({...data,confirm})}/>
      </div>
      {/* <TextInput label='Confirm Pin' placeholder={'e.g 4904290540'} required
        value={data?.confirm}
        onChange={(ev) => setData({...data,confirm: ev.target.value})}
      /> */}
      {forgotView ? 
        <div className='flex flex-col gap-2 text-primary/80'>
          <div className='flex items-center gap-4 justify-between'>
            <small>OTP</small>
            <div>
              <Button1 variant='text' loading={loadings?.resend} onClick={() => handleForgotPin(query,{resend: true})}>Resend OTP</Button1>
            </div>
          </div>
          <OTPInput value={data?.OTP} onChange={(OTP) => setData({...data,OTP})} />
        </div>
        // <TextInput label='OTP' value={data?.OTP} onChange={(ev) => setData({...data,OTP: ev.target.value})} />
      // : 
      // user?.advancedSecurityEnabled ?
      //   <div className='flex justify-end'>
      //       <button type='button' onClick={() => handleForgotPin()} className='text-blue-500 flex gap-2 items-center'>
      //           {loadings?.forgot ? 
      //               <CircularProgress className='!w-4 !h-4' />
      //           :null}
      //           Reset PIN
      //       </button>
      //   </div>
      : null}
      <div className='flex gap-4 items-center py-2'>
        {/* <div>
            {close ? 
                <Button1 type='button' variant='text' onClick={() => close()}>Close</Button1>
            :null}
        </div> */}
        <div className='flex-1 min-w-[200px]'>
          <Button1 type='submit' loading={loadings?.submit}>{!forgotView?"Continue":"Save"}</Button1>
        </div>
        <div className='flex-1'></div>
      </div>
    </form>
  )
}
